var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17.4 10.2a7.2 7.2 0 1 0-14.401 0 7.2 7.2 0 0 0 14.401 0m-1.901 5.723A7.76 7.76 0 0 1 10.2 18a7.8 7.8 0 0 1-7.8-7.8c0-4.309 3.491-7.8 7.8-7.8S18 5.891 18 10.2a7.76 7.76 0 0 1-2.078 5.299l5.652 5.647-.424.424z"
  })));
};
export default SvgSearch;